<script setup lang="ts">
import { ALIGNMENT } from '@pkg/sanity-utils/constants/alignment';
import { type PortableTextBlock } from 'sanity';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    tiles: Array<{
      _key: string,
      alignment: ALIGNMENT,
      icon?: string,
      preTitle?: string,
      title: string,
      content: Array<PortableTextBlock>,
      link?: any,
    }>,
    variant: string
    size: string
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  type: props.block?._type,
  tiles: props.block?.tiles,
  variant: props.block?.variant,
  size: props.block?.size,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data" :class="{'wrapper--large':  props.block?.size === 'large'}"/>
</template>

<style scoped>
.wrapper--large {
  --rows-override: 1;

  @screen tablet-wide {
    --rows-override: 2;
  }
}
</style>